import { fetchCustCategoriesApi } from "../api/fetchCustCategories";
import { fetchCustomersApi } from "../api/fetchCustomers";
import { fetchCustomerSalesApi } from "../api/fetchCustomerSales";
import { fetchCustomerStatus } from "../api/fetchCustomerStatus";
import { fetchSubCustCategoriesApi } from "../api/fetchSubCustCategories";
import { fetchSubCustomerSalesApi } from "../api/fetchSubCustomerSales";

export const member_main_category =
  "Life" | "Family" | "Individual" | "Student" | "Corporate" | "Honorary";
export const Gender = "MALE" | "FEMALE" | "OTHER";
// export const Status = "Active" | "Inactive";

export const Member = {
  id: null,
  member_name: "",
  joinDate: "",
  status: "",
  member_main_category: "",
  category_code: "",
  gender: "",
  subscriptionPaid: false,
  // lastPaymentDate: "",
  totalSpend: 0, // last 12m
  ageBracket: "",
  lastpossaledate: "",
  main_account_bal: 0,
  member_category_1: "",
  min_s_bal: 0.0,
  mobile: "",
  salesmonthttl: 0.0,
  cardtype: "",
  custno: null,
  subsElligible: false,
  subsAcBal: 0,
  suspended: false,
  statuscode: -1,
};

const TYPES = [
  "Life",
  "Family",
  "Individual",
  "Student",
  "Corporate",
  "Honorary",
];
const GENDERS = ["MALE", "FEMALE", "OTHER"];
const AGES = ["18-29", "30-44", "45-59", "60+", "Unknown"];

// Deterministic PRNG
function rng(seed) {
  let s = seed;
  return () => {
    s = (s * 1664525 + 1013904223) % 4294967296;
    return s / 4294967296;
  };
}

const firstNames = [
  "Alex",
  "Sam",
  "Jordan",
  "Taylor",
  "Casey",
  "Morgan",
  "Riley",
  "Jamie",
  "Drew",
  "Avery",
  "Cameron",
  "Quinn",
  "Skyler",
  "Rowan",
  "Parker",
  "Elliot",
  "Hayden",
  "Reese",
  "Sage",
  "Blake",
  "Devon",
  "Emerson",
  "Finley",
  "Harper",
  "Indigo",
  "Justice",
  "Kendall",
  "Logan",
  "Marlowe",
  "Noor",
];
const lastNames = [
  "Adler",
  "Brooks",
  "Chen",
  "Davies",
  "Evans",
  "Ferraro",
  "Gomez",
  "Hassan",
  "Iverson",
  "Jensen",
  "Kapoor",
  "Lopez",
  "Martin",
  "Nakamura",
  "Owens",
  "Patel",
  "Quinn",
  "Ramos",
  "Singh",
  "Tanaka",
  "Underwood",
  "Vargas",
  "Wright",
  "Xu",
  "Young",
  "Zhao",
];

export function generate() {
  const rand = rng(42);
  const members = [];
  const today = new Date();
  for (let i = 0; i < 10; i++) {
    const monthsAgo = Math.floor(rand() * 60); // up to 5y
    const join = new Date(today);
    join.setMonth(join.getMonth() - monthsAgo);
    const type = TYPES[Math.floor(rand() * TYPES.length)];
    const gender = GENDERS[Math.floor(rand() * (rand() > 0.05 ? 2 : 3))];
    const active = rand() > 0.28;
    const paid = active ? rand() > 0.18 : rand() > 0.75;
    // const lastPay = paid
    //   ? (() => {
    //       const d = new Date(today);
    //       d.setDate(d.getDate() - Math.floor(rand() * 300));
    //       return d.toISOString();
    //     })()
    //   : null;
    const baseSpend =
      type === "Corporate"
        ? 4000
        : type === "Life"
          ? 1800
          : type === "Family"
            ? 1400
            : type === "Student"
              ? 300
              : 900;
    const spend = active
      ? Math.round(baseSpend * (0.4 + rand() * 1.6))
      : Math.round(baseSpend * rand() * 0.4);
    members.push({
      id: `M-${1000 + i}`,
      member_name: `${firstNames[Math.floor(rand() * firstNames.length)]} ${lastNames[Math.floor(rand() * lastNames.length)]}`,
      joinDate: join.toISOString(),
      status: active ? "Active" : "Inactive",
      member_main_category: type,
      gender: gender,
      subscriptionPaid: paid,
      // lastPaymentDate: lastPay,
      totalSpend: spend,
      ageBracket: AGES[Math.floor(rand() * AGES.length)],
    });
  }
  return members;
}

// LIVE DATA

const getAgeBracket = (dateString) => {
  if (!dateString) return "Unknown";

  const birthDate = new Date(dateString);

  if (isNaN(birthDate.getTime())) return "Unknown";

  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  if (age >= 18 && age <= 29) return AGES[0]; // "18-29"
  if (age >= 30 && age <= 44) return AGES[1]; // "30-44"
  if (age >= 45 && age <= 59) return AGES[2]; // "45-59"
  if (age >= 60) return AGES[3]; // "60+"

  return "Unknown";
};

export async function getRangeCustomerSales(range) {
  // console.log(range);

  const tdy = new Date();
  const tdy2 = new Date();
  tdy2.setMonth(tdy2.getMonth() - 12);

  const yearAgo = tdy2.toLocaleDateString("en-CA");
  let startDate = yearAgo;
  let endDate = tdy.toLocaleDateString("en-CA");

  if (range === "12 Quarters") {
    const tdy3 = new Date();
    tdy3.setFullYear(tdy3.getFullYear() - 3);
    const l = tdy3.toLocaleDateString("en-CA");
    startDate = l;
  } else if (range === "5 Years") {
    const tdy4 = new Date();
    tdy4.setFullYear(tdy4.getFullYear() - 5);
    const v = tdy4.toLocaleDateString("en-CA");
    startDate = v;
  }

  let custSales = await fetchCustomerSalesApi(startDate, endDate);

  let subCustSales = await fetchSubCustomerSalesApi(startDate, endDate);

  return { custsales: custSales, subcustsales: subCustSales };
}

export async function getCustomers() {
  // fetch totalsales for last 12 months
  const members = [];

  try {
    //const tdy = new Date();
    const tdy2 = new Date();
    tdy2.setMonth(tdy2.getMonth() - 12);
    // const yearAgo = tdy2.toLocaleDateString("en-CA");
    // let custSales = await fetchCustomerSalesApi(
    //   yearAgo,
    //   tdy.toLocaleDateString("en-CA"),
    // );

    // let subCustSales = await fetchSubCustomerSalesApi(
    //   yearAgo,
    //   tdy.toLocaleDateString("en-CA"),
    // );

    let custCategories = (await fetchCustCategoriesApi()) ?? [];
    // console.log(custCategories);
    let subCustCategories = (await fetchSubCustCategoriesApi()) ?? [];
    // console.log(subCustCategories);
    let customerStatusList = (await fetchCustomerStatus()) ?? [];
    // console.log(customerStatus);
    let custlist = (await fetchCustomersApi()) ?? [];
    // console.log(custlist.length);

    // set today here, jus
    //const today = new Date();
    for (let i = 0; i < custlist.length; i++) {
      // subscription - subs_account_bal
      let subsPaid = false;
      subsPaid = custlist[i]["subs_account_bal"] <= 0;
      // console.log(custlist[i]["subs_account_bal"]);
      // console.log(subsPaid);
      let ageGroup = getAgeBracket(custlist[i]["birthdate"]);
      // console.log(custlist[i]["suspended"] !== "No");
      // console.log(custlist[i]["deleted"] !== "No");
      //console.log((custlist[i]["gender"] || "Other").toUpperCase());
      // console.log(custlist[i]["custno"]);
      // console.log(typeof custSales[0]["custcode"]);
      // console.log(typeof custlist[i]["custno"]);
      /// ***
      // let saleDict = null;
      // if (custlist[i]["cardtype"] === "CUST") {
      //   saleDict = custSales.find(
      //     (g) => g.custcode === custlist[i]["custno"].toString(),
      //   );
      // } else if (custlist[i]["cardtype"] === "CUSTSUB") {
      //   saleDict = subCustSales.find(
      //     (g) => g.subcustcode === custlist[i]["custno"].toString(),
      //   );
      // }
      // // console.log(saleDict);
      // let tSpend = 0;
      // if (saleDict) {
      //   tSpend = saleDict["samount"];
      // }
      ///***
      // console.log(tSpend);
      // let totalSpend = saleDict

      let memberCategory = "UNKNOWN";
      let subsElligible = false;

      if (custlist[i]["cardtype"] === "CUST") {
        let j = custCategories.find(
          (b) => b["maincatcode"] === custlist[i]["category_code"].toString(),
        );
        if (j) {
          memberCategory = j["maincategory"];
        }

        let f4 = custlist[i]["subsratecode"]; // -1, null
        //sub elligibilty, first check on individual
        // if not (-1 or null or "-1")
        if (f4) {
          if (!(f4 === null || (f4 ?? "").toString() === "-1")) {
            subsElligible = true;
          }
        }
        // if individual din't change, check category
        if (j && !subsElligible) {
          // subs elligibility based on category
          let p4 = j["subsratecode"];
          if (p4) {
            if (!(p4 === null || (p4 ?? "").toString === "-1")) {
              subsElligible = true;
            }
          }
        }
      } else {
        let j2 = subCustCategories.find(
          (b) => b["maincatcode"] === custlist[i]["category_code"].toString(),
        );
        if (j2) {
          memberCategory = j2["maincategory"];
          // sub cust categories don't have subratecode
          // we can check based on individuals
        }
        let f4 = custlist[i]["subsratecode"]; // -1, null
        //sub elligibilty, first check on individual
        // if not (-1 or null or "-1")
        // console.log(custlist[i]);
        // console.log(f4);
        if (f4) {
          if (!(f4 === null || (f4 ?? "").toString() === "-1")) {
            subsElligible = true;
          }
        }
      }

      let s = customerStatusList.find(
        (a) => a["custstatuscode"] === custlist[i]["statuscode"],
      );

      members.push({
        id: custlist[i]["id"],
        member_name: custlist[i]["member_name"],
        joinDate: custlist[i]["joindate"] ?? new Date(tdy2).toISOString(),
        // status:
        //   custlist[i]["deleted"] === "No"
        //     ? custlist[i]["suspended"] === "No"
        //       ? "Active"
        //       : "Inactive"
        //     : "Inactive",
        status: s ? s["custstatusname"] : "Unknown",
        // member_main_category: custlist[i]["member_main_category"],
        member_main_category: memberCategory,
        gender: (custlist[i]["gender"] || "Other").toUpperCase(),
        subscriptionPaid: subsPaid,
        // lastPaymentDate: "",
        // totalSpend: custlist[i]["totalspend"],
        totalSpend: 0,
        // totalSpend: tSpend, //last 12 months
        ageBracket: ageGroup,
        lastpossaledate: custlist[i]["lastpossaledate"],
        main_account_bal: custlist[i]["main_account_bal"],
        member_category_1: custlist[i]["member_category_1"],
        min_s_bal: custlist[i]["min_s_bal"],
        mobile: custlist[i]["mobile"],
        salesmonthttl: custlist[i]["salesmonthttl"],
        cardtype: custlist[i]["cardtype"],
        custno: custlist[i]["custno"],
        subsElligible: subsElligible,
        subsAcBal: custlist[i]["subs_account_bal"],
        suspended:
          (custlist[i]["suspended"] ?? "").toLowerCase() === "yes" ||
          (custlist[i]["deleted"] ?? "").toLowerCase() === "yes",
        statuscode: custlist[i]["statuscode"],
      });
    }
    //console.log(members);
  } catch (error) {
    // console.log(error);
  }
  return members;
}

// console.log(generate());
// export const MEMBERS = generate();
// export const MEMBERS = getCustomers();
